/** Read a File and return its bytes as a base64 string (no data: prefix) for the
 * `POST /rooms/:roomId/ingest/finalize` payload. Encodes in chunks so large
 * files don't blow the argument-count limit of String.fromCharCode(...). */
export async function fileToBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  const CHUNK = 0x8000; // 32 KiB per fromCharCode call
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

/** Browser-reported MIME type, with a safe fallback when the OS gives none. */
export function contentTypeOf(file: File): string {
  return file.type || 'application/octet-stream';
}
